import { render, staticRenderFns } from "./ReleaseHandle.vue?vue&type=template&id=9ad2115c&"
import script from "./ReleaseHandle.vue?vue&type=script&lang=js&"
export * from "./ReleaseHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports